import { Controller } from '@hotwired/stimulus'

// Friendly single-file upload field: shows the chosen filename, an image
// thumbnail (when the file is an image), and a "selected" state. Clicking the
// field again replaces the file. Used on the shop owner application page.
export default class extends Controller {
  static targets = ['input', 'placeholder', 'preview', 'filename', 'thumb', 'docIcon']

  connect () {
    this.url = null
  }

  disconnect () {
    this.revoke()
  }

  change () {
    const file = this.inputTarget.files && this.inputTarget.files[0]
    this.revoke()

    if (!file) {
      this.reset()
      return
    }

    if (this.hasFilenameTarget) this.filenameTarget.textContent = file.name

    const isImage = file.type.startsWith('image/')
    if (this.hasThumbTarget) {
      if (isImage) {
        this.url = URL.createObjectURL(file)
        this.thumbTarget.src = this.url
        this.thumbTarget.classList.remove('hidden')
      } else {
        this.thumbTarget.classList.add('hidden')
      }
    }
    if (this.hasDocIconTarget) this.docIconTarget.classList.toggle('hidden', isImage)

    if (this.hasPlaceholderTarget) this.placeholderTarget.classList.add('hidden')
    if (this.hasPreviewTarget) this.previewTarget.classList.remove('hidden')
  }

  reset () {
    if (this.hasPreviewTarget) this.previewTarget.classList.add('hidden')
    if (this.hasPlaceholderTarget) this.placeholderTarget.classList.remove('hidden')
    if (this.hasThumbTarget) {
      this.thumbTarget.src = ''
      this.thumbTarget.classList.add('hidden')
    }
  }

  revoke () {
    if (this.url) {
      URL.revokeObjectURL(this.url)
      this.url = null
    }
  }
}
